const KEYS = {
  ACCESS_TOKEN: 'na_access_token',
  ACCOUNT_UUID: 'na_account_uuid',
  USER_ID: 'na_user_id',
  TERMS_ACCEPTED: 'na_terms_accepted',
} as const;

export const sessionStorage = {
  getAccessToken(): string | null {
    return window.sessionStorage.getItem(KEYS.ACCESS_TOKEN);
  },

  setAccessToken(token: string): void {
    window.sessionStorage.setItem(KEYS.ACCESS_TOKEN, token);
  },

  getAccountUUID(): string | null {
    return window.sessionStorage.getItem(KEYS.ACCOUNT_UUID);
  },

  setAccountUUID(uuid: string): void {
    window.sessionStorage.setItem(KEYS.ACCOUNT_UUID, uuid);
  },

  getUserID(): string | null {
    return window.sessionStorage.getItem(KEYS.USER_ID);
  },

  setUserID(userID: string): void {
    window.sessionStorage.setItem(KEYS.USER_ID, userID);
  },

  getTermsAccepted(): boolean {
    return window.sessionStorage.getItem(KEYS.TERMS_ACCEPTED) === 'true';
  },

  setTermsAccepted(accepted: boolean): void {
    window.sessionStorage.setItem(KEYS.TERMS_ACCEPTED, String(accepted));
  },

  clearAuth(): void {
    window.sessionStorage.removeItem(KEYS.ACCESS_TOKEN);
    window.sessionStorage.removeItem(KEYS.ACCOUNT_UUID);
    window.sessionStorage.removeItem(KEYS.USER_ID);
    window.sessionStorage.removeItem(KEYS.TERMS_ACCEPTED);
  },

  isAuthenticated(): boolean {
    return !!window.sessionStorage.getItem(KEYS.ACCESS_TOKEN);
  },
};
